/**
 * Js for the landing (optimised)
 *
 * @copyright 2018 Linguistica 360
 */

import './shared/requirements.js';

import './widgets/consent.js';
import './widgets/navigation.js';
import './widgets/login.js';

import $ from 'jquery';
import { format } from 'date-fns';

$('.announcement-section .datetime').each(function () {
    const date = $(this).data('datetime');
    $(this).html(format(date, 'EEEE, MMMM d h:mm a'));
});
